import {ParameterStore} from './ParameterStore';

const evalhealthConditionsGuard = (parameterStore: ParameterStore) => {
    return parameterStore.prequal.healthConditions.value as boolean;
};
const evalBloodpressureGuard = (parameterStore: ParameterStore) => {
    return parameterStore.health.Bloodpressure.value as boolean;
};
const evalCholesterolGuard = (parameterStore: ParameterStore) => {
    return parameterStore.health.Cholesterol.value as boolean;
};
const evalType1DiabetesGuard = (parameterStore: ParameterStore) => {
    return parameterStore.health.Type1Diabetes.value as boolean;
};
const evalType2DiabetesGuard = (parameterStore: ParameterStore) => {
    return parameterStore.health.Type2Diabetes.value as boolean;
};
const evalAnxietyGuard = (parameterStore: ParameterStore) => {
    return parameterStore.health.Anxiety.value as boolean;
};
const evalDepressionGuard = (parameterStore: ParameterStore) => {
    return parameterStore.health.Depression.value as boolean;
};
const evalBipolarDisorderGuard = (parameterStore: ParameterStore) => {
    return parameterStore.health.BipolarDisorder.value as boolean;
};
const evalSchizophreniaGuard = (parameterStore: ParameterStore) => {
    return parameterStore.health.Schizophrenia.value as boolean;
};
const evalOsteoArthritisGuard = (parameterStore: ParameterStore) => {
    return parameterStore.health.OsteoArthritis.value as boolean;
};
const evalRheumatoidArthritisGuard = (parameterStore: ParameterStore) => {
    return parameterStore.health.RheumatoidArthritis.value as boolean;
};
const evalHerpesANDhealthConditionsGuard = (parameterStore: ParameterStore) => {
    return (parameterStore.health.Herpes.value && parameterStore.prequal.healthConditions.value) as boolean;
};
const evalADDADHDGuard = (parameterStore: ParameterStore) => {
    return parameterStore.health.ADDADHD.value as boolean;
};
const evalNarcolepsyGuard = (parameterStore: ParameterStore) => {
    return parameterStore.health.Narcolepsy.value as boolean;
};
const evalAsthmaGuard = (parameterStore: ParameterStore) => {
    return parameterStore.health.Asthma.value as boolean;
};
const evalCOPDGuard = (parameterStore: ParameterStore) => {
    return parameterStore.health.COPD.value as boolean;
};
const evalSleepApneaGuard = (parameterStore: ParameterStore) => {
    return parameterStore.health.SleepApnea.value as boolean;
};
const evalHeartFailureGuard = (parameterStore: ParameterStore) => {
    return parameterStore.health.HeartFailure.value as boolean;
};
const evalOsteoperosisGuard = (parameterStore: ParameterStore) => {
    return parameterStore.health.Osteoperosis.value as boolean;
};
const evalEnlargedProstateBenignProstaticHyperplasiaGuard = (parameterStore: ParameterStore) => {
    return parameterStore.health.EnlargedProstateBenignProstaticHyperplasia.value as boolean;
};
const evalGoutGuard = (parameterStore: ParameterStore) => {
    return parameterStore.health.Gout.value as boolean;
};
const evalKidneyStonesANDhealthConditionsGuard = (parameterStore: ParameterStore) => {
    return (parameterStore.health.KidneyStones.value && parameterStore.prequal.healthConditions.value) as boolean;
};
const evalParkinsonsDiseaseGuard = (parameterStore: ParameterStore) => {
    return parameterStore.health.ParkinsonsDisease.value as boolean;
};
const evalInsomniaANDhealthConditionsGuard = (parameterStore: ParameterStore) => {
    return (parameterStore.health.Insomnia.value && parameterStore.prequal.healthConditions.value) as boolean;
};
const evalVentricularTachycardiaGuard = (parameterStore: ParameterStore) => {
    return parameterStore.health.VentricularTachycardia.value as boolean;
};
const evalVentricularFibrillationGuard = (parameterStore: ParameterStore) => {
    return parameterStore.health.VentricularFibrillation.value as boolean;
};
const evalIBSIrritableBowelSyndromeGuard = (parameterStore: ParameterStore) => {
    return parameterStore.health.IBSIrritableBowelSyndrome.value as boolean;
};
const evalPneumoniaANDhealthConditionsGuard = (parameterStore: ParameterStore) => {
    return (parameterStore.health.Pneumonia.value && parameterStore.prequal.healthConditions.value) as boolean;
};
const evalBreastCancerGuard = (parameterStore: ParameterStore) => {
    return parameterStore.health.BreastCancer.value as boolean;
};
const evalAtrialFibulationAfibGuard = (parameterStore: ParameterStore) => {
    return parameterStore.health.AtrialFibulationAfib.value as boolean;
};
const evalBloodClotinthelungsPulmonaryEmbolismANDhealthConditionsGuard = (parameterStore: ParameterStore) => {
    return (parameterStore.health.BloodClotinthelungsPulmonaryEmbolism.value &&
        parameterStore.prequal.healthConditions.value) as boolean;
};
const evalBloodClotDVTDeepVeinThrombosisGuard = (parameterStore: ParameterStore) => {
    return parameterStore.health.BloodClotDVTDeepVeinThrombosis.value as boolean;
};
const evalDementiaAlzheimersGuard = (parameterStore: ParameterStore) => {
    return parameterStore.health.DementiaAlzheimers.value as boolean;
};
const evalBronchitisANDhealthConditionsGuard = (parameterStore: ParameterStore) => {
    return (parameterStore.health.Bronchitis.value && parameterStore.prequal.healthConditions.value) as boolean;
};
const evalUTIUrinaryTractInfectionANDhealthConditionsGuard = (parameterStore: ParameterStore) => {
    return (parameterStore.health.UTIUrinaryTractInfection.value &&
        parameterStore.prequal.healthConditions.value) as boolean;
};
const evalSexuallytransmitteddiseasesANDhealthConditionsGuard = (parameterStore: ParameterStore) => {
    return (parameterStore.health.Sexuallytransmitteddiseases.value &&
        parameterStore.prequal.healthConditions.value) as boolean;
};
const evalConjuctivaANDhealthConditionsGuard = (parameterStore: ParameterStore) => {
    return (parameterStore.health.Conjuctiva.value && parameterStore.prequal.healthConditions.value) as boolean;
};
const evalMSMultipleSclerosisGuard = (parameterStore: ParameterStore) => {
    return parameterStore.health.MSMultipleSclerosis.value as boolean;
};
const evalMuscleSpasmsANDhealthConditionsGuard = (parameterStore: ParameterStore) => {
    return (parameterStore.health.MuscleSpasms.value && parameterStore.prequal.healthConditions.value) as boolean;
};
const evalStaphInfectionANDhealthConditionsGuard = (parameterStore: ParameterStore) => {
    return (parameterStore.health.StaphInfection.value && parameterStore.prequal.healthConditions.value) as boolean;
};
const evalCoronavirusCovid19ANDhealthConditionsGuard = (parameterStore: ParameterStore) => {
    return (parameterStore.health.CoronavirusCovid19.value && parameterStore.prequal.healthConditions.value) as boolean;
};
const evalEczemaANDhealthConditionsGuard = (parameterStore: ParameterStore) => {
    return (parameterStore.health.Eczema.value && parameterStore.prequal.healthConditions.value) as boolean;
};
const evalPsoriasisGuard = (parameterStore: ParameterStore) => {
    return parameterStore.health.Psoriasis.value as boolean;
};
const evalProstateCancerGuard = (parameterStore: ParameterStore) => {
    return parameterStore.health.ProstateCancer.value as boolean;
};
const evalHIVAIDSANDhealthConditionsGuard = (parameterStore: ParameterStore) => {
    return (parameterStore.health.HIVAIDS.value && parameterStore.prequal.healthConditions.value) as boolean;
};
const evalGlaucomaANDhealthConditionsGuard = (parameterStore: ParameterStore) => {
    return (parameterStore.health.Glaucoma.value && parameterStore.prequal.healthConditions.value) as boolean;
};
const evalCrohnsDiseaseGuard = (parameterStore: ParameterStore) => {
    return parameterStore.health.CrohnsDisease.value as boolean;
};
const evalOpioidAddictionANDhealthConditionsGuard = (parameterStore: ParameterStore) => {
    return (parameterStore.health.OpioidAddiction.value && parameterStore.prequal.healthConditions.value) as boolean;
};
const evalUlcersGuard = (parameterStore: ParameterStore) => {
    return parameterStore.health.Ulcers.value as boolean;
};
const evalSeizuresEpilepsyPetitMalGuard = (parameterStore: ParameterStore) => {
    return parameterStore.health.SeizuresEpilepsyPetitMal.value as boolean;
};
const evalSeizuresEpilepsyGrandMalGuard = (parameterStore: ParameterStore) => {
    return parameterStore.health.SeizuresEpilepsyGrandMal.value as boolean;
};
const evalAllergiesHayFeverANDhealthConditionsGuard = (parameterStore: ParameterStore) => {
    return (parameterStore.health.AllergiesHayFever.value && parameterStore.prequal.healthConditions.value) as boolean;
};
const evalStrokeGuard = (parameterStore: ParameterStore) => {
    return parameterStore.health.Stroke.value as boolean;
};
const evalYeastInfectionANDhealthConditionsGuard = (parameterStore: ParameterStore) => {
    return (parameterStore.health.YeastInfection.value && parameterStore.prequal.healthConditions.value) as boolean;
};
const evalPainMedicationANDhealthConditionsGuard = (parameterStore: ParameterStore) => {
    return (parameterStore.health.PainMedication.value && parameterStore.prequal.healthConditions.value) as boolean;
};
const evalMuscleRelaxantANDhealthConditionsGuard = (parameterStore: ParameterStore) => {
    return (parameterStore.health.MuscleRelaxant.value && parameterStore.prequal.healthConditions.value) as boolean;
};
const evalUlcerativeColitisGuard = (parameterStore: ParameterStore) => {
    return parameterStore.health.UlcerativeColitis.value as boolean;
};
const evalGERDHeartburnGuard = (parameterStore: ParameterStore) => {
    return parameterStore.health.GERDHeartburn.value as boolean;
};
const evalAnginaChestPainGuard = (parameterStore: ParameterStore) => {
    return parameterStore.health.AnginaChestPain.value as boolean;
};
const evalFibromyalgiaGuard = (parameterStore: ParameterStore) => {
    return parameterStore.health.Fibromyalgia.value as boolean;
};
const evalHeadachesMigrainesANDhealthConditionsGuard = (parameterStore: ParameterStore) => {
    return (parameterStore.health.HeadachesMigraines.value && parameterStore.prequal.healthConditions.value) as boolean;
};
const evalHBVHepatitisBVirusANDhealthConditionsGuard = (parameterStore: ParameterStore) => {
    return (parameterStore.health.HBVHepatitisBVirus.value && parameterStore.prequal.healthConditions.value) as boolean;
};
const evalHCVHepatitisCVirusANDhealthConditionsGuard = (parameterStore: ParameterStore) => {
    return (parameterStore.health.HCVHepatitisCVirus.value && parameterStore.prequal.healthConditions.value) as boolean;
};
const evalAnemiaANDhealthConditionsGuard = (parameterStore: ParameterStore) => {
    return (parameterStore.health.Anemia.value && parameterStore.prequal.healthConditions.value) as boolean;
};
const evalHyperthyroidismGuard = (parameterStore: ParameterStore) => {
    return parameterStore.health.Hyperthyroidism.value as boolean;
};
const evalMenopauseANDhealthConditionsGuard = (parameterStore: ParameterStore) => {
    return (parameterStore.health.Menopause.value && parameterStore.prequal.healthConditions.value) as boolean;
};
const evalTuberculosisTBANDhealthConditionsGuard = (parameterStore: ParameterStore) => {
    return (parameterStore.health.TuberculosisTB.value && parameterStore.prequal.healthConditions.value) as boolean;
};
const evalHypothyroidismGuard = (parameterStore: ParameterStore) => {
    return parameterStore.health.Hypothyroidism.value as boolean;
};
const evalLeftBundleBranchBlockANDhealthConditionsGuard = (parameterStore: ParameterStore) => {
    return (parameterStore.health.LeftBundleBranchBlock.value &&
        parameterStore.prequal.healthConditions.value) as boolean;
};
const evalRightBundleBranchBlockANDhealthConditionsGuard = (parameterStore: ParameterStore) => {
    return (parameterStore.health.RightBundleBranchBlock.value &&
        parameterStore.prequal.healthConditions.value) as boolean;
};
const evalAVBlockGuard = (parameterStore: ParameterStore) => {
    return parameterStore.health.AVBlock.value as boolean;
};
const evalDiarrheaANDhealthConditionsGuard = (parameterStore: ParameterStore) => {
    return (parameterStore.health.Diarrhea.value && parameterStore.prequal.healthConditions.value) as boolean;
};
const evalMeningitisANDhealthConditionsGuard = (parameterStore: ParameterStore) => {
    return (parameterStore.health.Meningitis.value && parameterStore.prequal.healthConditions.value) as boolean;
};
const evalAddisonsDiseaseANDhealthConditionsGuard = (parameterStore: ParameterStore) => {
    return (parameterStore.health.AddisonsDisease.value && parameterStore.prequal.healthConditions.value) as boolean;
};
const evalAdrenogenitalSyndromeANDhealthConditionsGuard = (parameterStore: ParameterStore) => {
    return (parameterStore.health.AdrenogenitalSyndrome.value &&
        parameterStore.prequal.healthConditions.value) as boolean;
};
const evalBulimiaANDhealthConditionsGuard = (parameterStore: ParameterStore) => {
    return (parameterStore.health.Bulimia.value && parameterStore.prequal.healthConditions.value) as boolean;
};
const evalOCDObsessiveCompulsiveDisorderANDhealthConditionsGuard = (parameterStore: ParameterStore) => {
    return (parameterStore.health.OCDObsessiveCompulsiveDisorder.value &&
        parameterStore.prequal.healthConditions.value) as boolean;
};
const evalPagetsDiseaseANDhealthConditionsGuard = (parameterStore: ParameterStore) => {
    return (parameterStore.health.PagetsDisease.value && parameterStore.prequal.healthConditions.value) as boolean;
};
const evalBladderInfectionANDhealthConditionsGuard = (parameterStore: ParameterStore) => {
    return (parameterStore.health.BladderInfection.value && parameterStore.prequal.healthConditions.value) as boolean;
};
const evalLiverDiseaseGuard = (parameterStore: ParameterStore) => {
    return parameterStore.health.LiverDisease.value as boolean;
};
const evalKidneyDisorderKidneyDiseaseGuard = (parameterStore: ParameterStore) => {
    return parameterStore.health.KidneyDisorderKidneyDisease.value as boolean;
};
const evalRestlessLegSyndromeRLSANDhealthConditionsGuard = (parameterStore: ParameterStore) => {
    return (parameterStore.health.RestlessLegSyndromeRLS.value &&
        parameterStore.prequal.healthConditions.value) as boolean;
};
const evalCancerGuard = (parameterStore: ParameterStore) => {
    return parameterStore.health.Cancer.value as boolean;
};
const evalBacterialInfectionANDhealthConditionsGuard = (parameterStore: ParameterStore) => {
    return (parameterStore.health.BacterialInfection.value && parameterStore.prequal.healthConditions.value) as boolean;
};
const evalLeukemiaGuard = (parameterStore: ParameterStore) => {
    return parameterStore.health.Leukemia.value as boolean;
};
const evalSkinCancerMelanomaGuard = (parameterStore: ParameterStore) => {
    return parameterStore.health.SkinCancerMelanoma.value as boolean;
};
const evalHypoglycemiaGuard = (parameterStore: ParameterStore) => {
    return parameterStore.health.Hypoglycemia.value as boolean;
};
const evalCysticFibrosisANDhealthConditionsGuard = (parameterStore: ParameterStore) => {
    return (parameterStore.health.CysticFibrosis.value && parameterStore.prequal.healthConditions.value) as boolean;
};
const evalNauseaANDhealthConditionsGuard = (parameterStore: ParameterStore) => {
    return (parameterStore.health.Nausea.value && parameterStore.prequal.healthConditions.value) as boolean;
};
const evalTourettesSyndromeANDhealthConditionsGuard = (parameterStore: ParameterStore) => {
    return (parameterStore.health.TourettesSyndrome.value && parameterStore.prequal.healthConditions.value) as boolean;
};
const evalLupusGuard = (parameterStore: ParameterStore) => {
    return parameterStore.health.Lupus.value as boolean;
};
const evalMalariaANDhealthConditionsGuard = (parameterStore: ParameterStore) => {
    return (parameterStore.health.Malaria.value && parameterStore.prequal.healthConditions.value) as boolean;
};
const evalOvarianCancerGuard = (parameterStore: ParameterStore) => {
    return parameterStore.health.OvarianCancer.value as boolean;
};
const evalLymphomaGuard = (parameterStore: ParameterStore) => {
    return parameterStore.health.Lymphoma.value as boolean;
};
const evalBasalCellCarcinomaGuard = (parameterStore: ParameterStore) => {
    return parameterStore.health.BasalCellCarcinoma.value as boolean;
};
const evalHPVANDhealthConditionsGuard = (parameterStore: ParameterStore) => {
    return (parameterStore.health.HPV.value && parameterStore.prequal.healthConditions.value) as boolean;
};
const evalEmphysemaANDhealthConditionsGuard = (parameterStore: ParameterStore) => {
    return (parameterStore.health.Emphysema.value && parameterStore.prequal.healthConditions.value) as boolean;
};
const evalTardiveDyskinesiaANDhealthConditionsGuard = (parameterStore: ParameterStore) => {
    return (parameterStore.health.TardiveDyskinesia.value && parameterStore.prequal.healthConditions.value) as boolean;
};
const evalAcneANDhealthConditionsGuard = (parameterStore: ParameterStore) => {
    return (parameterStore.health.Acne.value && parameterStore.prequal.healthConditions.value) as boolean;
};
const evalFungalInfectionANDhealthConditionsGuard = (parameterStore: ParameterStore) => {
    return (parameterStore.health.FungalInfection.value && parameterStore.prequal.healthConditions.value) as boolean;
};
const evalBirthControlANDhealthConditionsGuard = (parameterStore: ParameterStore) => {
    return (parameterStore.health.BirthControl.value && parameterStore.prequal.healthConditions.value) as boolean;
};
const evalMyelofibrosisANDhealthConditionsGuard = (parameterStore: ParameterStore) => {
    return (parameterStore.health.Myelofibrosis.value && parameterStore.prequal.healthConditions.value) as boolean;
};
const evalHormoneReplacementTherapyANDhealthConditionsGuard = (parameterStore: ParameterStore) => {
    return (parameterStore.health.HormoneReplacementTherapy.value &&
        parameterStore.prequal.healthConditions.value) as boolean;
};
const evalEndometriosisANDhealthConditionsGuard = (parameterStore: ParameterStore) => {
    return (parameterStore.health.Endometriosis.value && parameterStore.prequal.healthConditions.value) as boolean;
};
const evalHyperkalemiaANDhealthConditionsGuard = (parameterStore: ParameterStore) => {
    return (parameterStore.health.Hyperkalemia.value && parameterStore.prequal.healthConditions.value) as boolean;
};
const evalPanicDisorderANDhealthConditionsGuard = (parameterStore: ParameterStore) => {
    return (parameterStore.health.PanicDisorder.value && parameterStore.prequal.healthConditions.value) as boolean;
};
const evalMultipleMyelomaANDhealthConditionsGuard = (parameterStore: ParameterStore) => {
    return (parameterStore.health.MultipleMyeloma.value && parameterStore.prequal.healthConditions.value) as boolean;
};
const evalConstipationANDhealthConditionsGuard = (parameterStore: ParameterStore) => {
    return (parameterStore.health.Constipation.value && parameterStore.prequal.healthConditions.value) as boolean;
};
const evalOveractiveBladderANDhealthConditionsGuard = (parameterStore: ParameterStore) => {
    return (parameterStore.health.OveractiveBladder.value && parameterStore.prequal.healthConditions.value) as boolean;
};
const evalOpioidEmergencyANDhealthConditionsGuard = (parameterStore: ParameterStore) => {
    return (parameterStore.health.OpioidEmergency.value && parameterStore.prequal.healthConditions.value) as boolean;
};
const evalNeutropeniaANDhealthConditionsGuard = (parameterStore: ParameterStore) => {
    return (parameterStore.health.Neutropenia.value && parameterStore.prequal.healthConditions.value) as boolean;
};
const evalIdiopathicPulmonaryFibrosisIPFANDhealthConditionsGuard = (parameterStore: ParameterStore) => {
    return (parameterStore.health.IdiopathicPulmonaryFibrosisIPF.value &&
        parameterStore.prequal.healthConditions.value) as boolean;
};
const evalWeightLossObesityGastricANDhealthConditionsGuard = (parameterStore: ParameterStore) => {
    return (parameterStore.health.WeightLossObesityGastric.value &&
        parameterStore.prequal.healthConditions.value) as boolean;
};
const evalInfluenzaFluANDhealthConditionsGuard = (parameterStore: ParameterStore) => {
    return (parameterStore.health.InfluenzaFlu.value && parameterStore.prequal.healthConditions.value) as boolean;
};
const evalPostTraumaticStressDisorderPTSDANDhealthConditionsGuard = (parameterStore: ParameterStore) => {
    return (parameterStore.health.PostTraumaticStressDisorderPTSD.value &&
        parameterStore.prequal.healthConditions.value) as boolean;
};
const evalHypokalemiaANDhealthConditionsGuard = (parameterStore: ParameterStore) => {
    return (parameterStore.health.Hypokalemia.value && parameterStore.prequal.healthConditions.value) as boolean;
};
const evalCongestionANDhealthConditionsGuard = (parameterStore: ParameterStore) => {
    return (parameterStore.health.Congestion.value && parameterStore.prequal.healthConditions.value) as boolean;
};
const evalExcessiveUnderarmSweatingANDhealthConditionsGuard = (parameterStore: ParameterStore) => {
    return (parameterStore.health.ExcessiveUnderarmSweating.value &&
        parameterStore.prequal.healthConditions.value) as boolean;
};
const evalTumorANDhealthConditionsGuard = (parameterStore: ParameterStore) => {
    return (parameterStore.health.Tumor.value && parameterStore.prequal.healthConditions.value) as boolean;
};
const evalHeartArrythmiaANDhealthConditionsGuard = (parameterStore: ParameterStore) => {
    return (parameterStore.health.HeartArrythmia.value && parameterStore.prequal.healthConditions.value) as boolean;
};
const evalShinglesANDhealthConditionsGuard = (parameterStore: ParameterStore) => {
    return (parameterStore.health.Shingles.value && parameterStore.prequal.healthConditions.value) as boolean;
};
const evalChronicDryEyeANDhealthConditionsGuard = (parameterStore: ParameterStore) => {
    return (parameterStore.health.ChronicDryEye.value && parameterStore.prequal.healthConditions.value) as boolean;
};
const evalTetanusLockjawANDhealthConditionsGuard = (parameterStore: ParameterStore) => {
    return (parameterStore.health.TetanusLockjaw.value && parameterStore.prequal.healthConditions.value) as boolean;
};
const evalErectileDysfunctionANDhealthConditionsGuard = (parameterStore: ParameterStore) => {
    return (parameterStore.health.ErectileDysfunction.value &&
        parameterStore.prequal.healthConditions.value) as boolean;
};
const evalTransplantANDhealthConditionsGuard = (parameterStore: ParameterStore) => {
    return (parameterStore.health.Transplant.value && parameterStore.prequal.healthConditions.value) as boolean;
};
const evalCoughANDhealthConditionsGuard = (parameterStore: ParameterStore) => {
    return (parameterStore.health.Cough.value && parameterStore.prequal.healthConditions.value) as boolean;
};
const evalCirrhosisoftheLiverANDhealthConditionsGuard = (parameterStore: ParameterStore) => {
    return (parameterStore.health.CirrhosisoftheLiver.value &&
        parameterStore.prequal.healthConditions.value) as boolean;
};
const evalUrinaryRetentionANDhealthConditionsGuard = (parameterStore: ParameterStore) => {
    return (parameterStore.health.UrinaryRetention.value && parameterStore.prequal.healthConditions.value) as boolean;
};
const evalGallstonesANDhealthConditionsGuard = (parameterStore: ParameterStore) => {
    return (parameterStore.health.Gallstones.value && parameterStore.prequal.healthConditions.value) as boolean;
};
const evalSmokingCessationQuitSmokingANDhealthConditionsGuard = (parameterStore: ParameterStore) => {
    return (parameterStore.health.SmokingCessationQuitSmoking.value &&
        parameterStore.prequal.healthConditions.value) as boolean;
};
const evalEatingDisorderANDhealthConditionsGuard = (parameterStore: ParameterStore) => {
    return (parameterStore.health.EatingDisorder.value && parameterStore.prequal.healthConditions.value) as boolean;
};
const evalChronicHivesANDhealthConditionsGuard = (parameterStore: ParameterStore) => {
    return (parameterStore.health.ChronicHives.value && parameterStore.prequal.healthConditions.value) as boolean;
};
const evalPolypsANDhealthConditionsGuard = (parameterStore: ParameterStore) => {
    return (parameterStore.health.Polyps.value && parameterStore.prequal.healthConditions.value) as boolean;
};
const evalObstructiveAirwayDiseaseANDhealthConditionsGuard = (parameterStore: ParameterStore) => {
    return (parameterStore.health.ObstructiveAirwayDisease.value &&
        parameterStore.prequal.healthConditions.value) as boolean;
};
const evalCataplexyANDhealthConditionsGuard = (parameterStore: ParameterStore) => {
    return (parameterStore.health.Cataplexy.value && parameterStore.prequal.healthConditions.value) as boolean;
};
const evalPleuralMesotheliomaANDhealthConditionsGuard = (parameterStore: ParameterStore) => {
    return (parameterStore.health.PleuralMesothelioma.value &&
        parameterStore.prequal.healthConditions.value) as boolean;
};

export const healthGuards: {[key: string]: (parameterStore: ParameterStore) => boolean} = {
    Herpes: evalhealthConditionsGuard,
    KidneyStones: evalhealthConditionsGuard,
    Insomnia: evalhealthConditionsGuard,
    Pneumonia: evalhealthConditionsGuard,
    BloodClotinthelungsPulmonaryEmbolism: evalhealthConditionsGuard,
    Bronchitis: evalhealthConditionsGuard,
    UTIUrinaryTractInfection: evalhealthConditionsGuard,
    Sexuallytransmitteddiseases: evalhealthConditionsGuard,
    Conjuctiva: evalhealthConditionsGuard,
    MuscleSpasms: evalhealthConditionsGuard,
    StaphInfection: evalhealthConditionsGuard,
    CoronavirusCovid19: evalhealthConditionsGuard,
    Eczema: evalhealthConditionsGuard,
    HIVAIDS: evalhealthConditionsGuard,
    Glaucoma: evalhealthConditionsGuard,
    OpioidAddiction: evalhealthConditionsGuard,
    AllergiesHayFever: evalhealthConditionsGuard,
    YeastInfection: evalhealthConditionsGuard,
    PainMedication: evalhealthConditionsGuard,
    MuscleRelaxant: evalhealthConditionsGuard,
    HeadachesMigraines: evalhealthConditionsGuard,
    HBVHepatitisBVirus: evalhealthConditionsGuard,
    HCVHepatitisCVirus: evalhealthConditionsGuard,
    Anemia: evalhealthConditionsGuard,
    Menopause: evalhealthConditionsGuard,
    TuberculosisTB: evalhealthConditionsGuard,
    LeftBundleBranchBlock: evalhealthConditionsGuard,
    RightBundleBranchBlock: evalhealthConditionsGuard,
    Diarrhea: evalhealthConditionsGuard,
    Meningitis: evalhealthConditionsGuard,
    AddisonsDisease: evalhealthConditionsGuard,
    AdrenogenitalSyndrome: evalhealthConditionsGuard,
    Bulimia: evalhealthConditionsGuard,
    OCDObsessiveCompulsiveDisorder: evalhealthConditionsGuard,
    PagetsDisease: evalhealthConditionsGuard,
    BladderInfection: evalhealthConditionsGuard,
    RestlessLegSyndromeRLS: evalhealthConditionsGuard,
    BacterialInfection: evalhealthConditionsGuard,
    CysticFibrosis: evalhealthConditionsGuard,
    Nausea: evalhealthConditionsGuard,
    TourettesSyndrome: evalhealthConditionsGuard,
    Malaria: evalhealthConditionsGuard,
    HPV: evalhealthConditionsGuard,
    Emphysema: evalhealthConditionsGuard,
    TardiveDyskinesia: evalhealthConditionsGuard,
    Acne: evalhealthConditionsGuard,
    FungalInfection: evalhealthConditionsGuard,
    BirthControl: evalhealthConditionsGuard,
    Myelofibrosis: evalhealthConditionsGuard,
    HormoneReplacementTherapy: evalhealthConditionsGuard,
    Endometriosis: evalhealthConditionsGuard,
    Hyperkalemia: evalhealthConditionsGuard,
    PanicDisorder: evalhealthConditionsGuard,
    MultipleMyeloma: evalhealthConditionsGuard,
    Constipation: evalhealthConditionsGuard,
    OveractiveBladder: evalhealthConditionsGuard,
    OpioidEmergency: evalhealthConditionsGuard,
    Neutropenia: evalhealthConditionsGuard,
    IdiopathicPulmonaryFibrosisIPF: evalhealthConditionsGuard,
    WeightLossObesityGastric: evalhealthConditionsGuard,
    InfluenzaFlu: evalhealthConditionsGuard,
    PostTraumaticStressDisorderPTSD: evalhealthConditionsGuard,
    Hypokalemia: evalhealthConditionsGuard,
    Congestion: evalhealthConditionsGuard,
    ExcessiveUnderarmSweating: evalhealthConditionsGuard,
    Tumor: evalhealthConditionsGuard,
    HeartArrythmia: evalhealthConditionsGuard,
    Shingles: evalhealthConditionsGuard,
    ChronicDryEye: evalhealthConditionsGuard,
    TetanusLockjaw: evalhealthConditionsGuard,
    ErectileDysfunction: evalhealthConditionsGuard,
    Transplant: evalhealthConditionsGuard,
    Cough: evalhealthConditionsGuard,
    CirrhosisoftheLiver: evalhealthConditionsGuard,
    UrinaryRetention: evalhealthConditionsGuard,
    Gallstones: evalhealthConditionsGuard,
    SmokingCessationQuitSmoking: evalhealthConditionsGuard,
    EatingDisorder: evalhealthConditionsGuard,
    ChronicHives: evalhealthConditionsGuard,
    Polyps: evalhealthConditionsGuard,
    ObstructiveAirwayDisease: evalhealthConditionsGuard,
    Cataplexy: evalhealthConditionsGuard,
    PleuralMesothelioma: evalhealthConditionsGuard,
    bpDiagnosisDate: evalBloodpressureGuard,
    bpNumMedications: evalBloodpressureGuard,
    bpReadingLow: evalBloodpressureGuard,
    bpReadingHigh: evalBloodpressureGuard,
    bpMedications: evalBloodpressureGuard,
    cholesterolDiagnosisDate: evalCholesterolGuard,
    cholesterolMedications: evalCholesterolGuard,
    cholesterolChecked: evalCholesterolGuard,
    cholesterolReading: evalCholesterolGuard,
    cholesterolReadingAlt: evalCholesterolGuard,
    type1DiagnosisDate: evalType1DiabetesGuard,
    type1A1CReading: evalType1DiabetesGuard,
    type1Treatment: evalType1DiabetesGuard,
    type1Complications: evalType1DiabetesGuard,
    type2DiagnosisDate: evalType2DiabetesGuard,
    type2A1CReading: evalType2DiabetesGuard,
    type2Treatment: evalType2DiabetesGuard,
    type2Complications: evalType2DiabetesGuard,
    type2DiagnosisAge: evalType2DiabetesGuard,
    anxietyDiagnosisDate: evalAnxietyGuard,
    anxietySeverity: evalAnxietyGuard,
    anxietyMedications: evalAnxietyGuard,
    anxietyHospilization: evalAnxietyGuard,
    anxietyTreatment: evalAnxietyGuard,
    anxietySuicideAttempts: evalAnxietyGuard,
    depressionDiagnosisDate: evalDepressionGuard,
    depressionSeverity: evalDepressionGuard,
    depressionHospitalizations: evalDepressionGuard,
    depressionTreatment: evalDepressionGuard,
    depressionInpatient: evalDepressionGuard,
    depressionSuicideAttempts: evalDepressionGuard,
    bipolarDiagnosisDate: evalBipolarDisorderGuard,
    bipolarMedications: evalBipolarDisorderGuard,
    bipolarYearsStable: evalBipolarDisorderGuard,
    bipolarHospitalizations: evalBipolarDisorderGuard,
    schizophreniaDiagnosisDate: evalSchizophreniaGuard,
    schizophreniaMedications: evalSchizophreniaGuard,
    schizophreniaYearsStable: evalSchizophreniaGuard,
    schizophreniaHospitalizations: evalSchizophreniaGuard,
    osteoarthritisDiagnosisDate: evalOsteoArthritisGuard,
    osteoarthritisTreatment: evalOsteoArthritisGuard,
    osteoarthritisSideEffects: evalOsteoArthritisGuard,
    rheumatoidarthritisDiagnosisDate: evalRheumatoidArthritisGuard,
    rhuematoidarthritisImmunoMedication: evalRheumatoidArthritisGuard,
    rheumatoidarthritisSideEffects: evalRheumatoidArthritisGuard,
    rheumatoidarthritisTreatment: evalRheumatoidArthritisGuard,
    herpesDiagnosisDate: evalHerpesANDhealthConditionsGuard,
    herpesPendingDiagnosis: evalHerpesANDhealthConditionsGuard,
    addDiagnosisDate: evalADDADHDGuard,
    addYearsStable: evalADDADHDGuard,
    addSideEffects: evalADDADHDGuard,
    addTreatment: evalADDADHDGuard,
    narcolepsyDiagnosisDate: evalNarcolepsyGuard,
    narcolepsyPendingDiagnosis: evalNarcolepsyGuard,
    asthmaDiagnosisDate: evalAsthmaGuard,
    asthmaSeverity: evalAsthmaGuard,
    asthmaHospitalizations: evalAsthmaGuard,
    asthmaSteroids: evalAsthmaGuard,
    copdDiagnosisDate: evalCOPDGuard,
    copdOxygenUsage: evalCOPDGuard,
    copdSymptoms: evalCOPDGuard,
    copdMedications: evalCOPDGuard,
    sleepapneaDiagnosisDate: evalSleepApneaGuard,
    sleepapneaSeverity: evalSleepApneaGuard,
    sleepapneaTreatment: evalSleepApneaGuard,
    heartfailureDiagnosisAge: evalHeartFailureGuard,
    heartfailureBloodThinners: evalHeartFailureGuard,
    heartfailureSurgery: evalHeartFailureGuard,
    heartfailureTreatment: evalHeartFailureGuard,
    heartfailureCardiologistVisit: evalHeartFailureGuard,
    osteoperosisDiagnosisDate: evalOsteoperosisGuard,
    osteoperosisConditions: evalOsteoperosisGuard,
    osteoperosisTreatment: evalOsteoperosisGuard,
    enlargedprostateDiagnosisDate: evalEnlargedProstateBenignProstaticHyperplasiaGuard,
    enlargedprostatePendingDiagnosis: evalEnlargedProstateBenignProstaticHyperplasiaGuard,
    enlargedprostateCancerous: evalEnlargedProstateBenignProstaticHyperplasiaGuard,
    enlargedprostateEvaluations: evalEnlargedProstateBenignProstaticHyperplasiaGuard,
    enlargedprostateDiagnosis: evalEnlargedProstateBenignProstaticHyperplasiaGuard,
    enlargedprostateTreatment: evalEnlargedProstateBenignProstaticHyperplasiaGuard,
    goutDiagnosisDate: evalGoutGuard,
    goutPendingDiagnosis: evalGoutGuard,
    goutTreatmentPlan: evalGoutGuard,
    kidneystonesDiagnosisDate: evalKidneyStonesANDhealthConditionsGuard,
    kidneystonesResolved: evalKidneyStonesANDhealthConditionsGuard,
    parkinsonsDiagnosisDate: evalParkinsonsDiseaseGuard,
    parkinsonsTreatment: evalParkinsonsDiseaseGuard,
    insomniaDiagnosisDate: evalInsomniaANDhealthConditionsGuard,
    insomniaResults: evalInsomniaANDhealthConditionsGuard,
    ventriculartachycardiaDiagnosisDate: evalVentricularTachycardiaGuard,
    ventriculartachycardiaTreatmentPlan: evalVentricularTachycardiaGuard,
    ventriculartachycardiaSymptoms: evalVentricularTachycardiaGuard,
    ventriculartachycardiaAblation: evalVentricularTachycardiaGuard,
    vFibDiagnosisDate: evalVentricularFibrillationGuard,
    vFibTreatment: evalVentricularFibrillationGuard,
    vFibSurgeryDate: evalVentricularFibrillationGuard,
    vFibSymptoms: evalVentricularFibrillationGuard,
    vFibAblationDate: evalVentricularFibrillationGuard,
    ibsDiagnosisDate: evalIBSIrritableBowelSyndromeGuard,
    ibsCondition: evalIBSIrritableBowelSyndromeGuard,
    ibsTreatment: evalIBSIrritableBowelSyndromeGuard,
    pneumoniaDiagnosisDate: evalPneumoniaANDhealthConditionsGuard,
    pneumoniaTreatmentCompleted: evalPneumoniaANDhealthConditionsGuard,
    parkinsonsSymptoms: evalPneumoniaANDhealthConditionsGuard,
    breastcancerYearsRemission: evalBreastCancerGuard,
    breastcancerTypeStage: evalBreastCancerGuard,
    breastcancerTreatment: evalBreastCancerGuard,
    afibDiagnosisDate: evalAtrialFibulationAfibGuard,
    afibAblation: evalAtrialFibulationAfibGuard,
    afibResolved: evalAtrialFibulationAfibGuard,
    afibEpisodes: evalAtrialFibulationAfibGuard,
    afibHeartDisease: evalAtrialFibulationAfibGuard,
    pulmonaryembolismDiagnosisDate: evalBloodClotinthelungsPulmonaryEmbolismANDhealthConditionsGuard,
    pulmonaryembolismSymptoms: evalBloodClotinthelungsPulmonaryEmbolismANDhealthConditionsGuard,
    pulmonaryembolismTreatment: evalBloodClotinthelungsPulmonaryEmbolismANDhealthConditionsGuard,
    dvtDiagnosisDate: evalBloodClotDVTDeepVeinThrombosisGuard,
    dvtResolved: evalBloodClotDVTDeepVeinThrombosisGuard,
    dvtEpisodes: evalBloodClotDVTDeepVeinThrombosisGuard,
    dvtLastEpisode: evalBloodClotDVTDeepVeinThrombosisGuard,
    dvtTreatment: evalBloodClotDVTDeepVeinThrombosisGuard,
    alzheimersDiagnosis: evalDementiaAlzheimersGuard,
    bronchitisDiagnosisDate: evalBronchitisANDhealthConditionsGuard,
    bronchitisChronic: evalBronchitisANDhealthConditionsGuard,
    bronchitisEpisodes: evalBronchitisANDhealthConditionsGuard,
    bronchitisRecovery: evalBronchitisANDhealthConditionsGuard,
    bronchitisSymptoms: evalBronchitisANDhealthConditionsGuard,
    bronchitisTreatment: evalBronchitisANDhealthConditionsGuard,
    utiDiagnosisDate: evalUTIUrinaryTractInfectionANDhealthConditionsGuard,
    utiPendingDiagnsois: evalUTIUrinaryTractInfectionANDhealthConditionsGuard,
    utiEpisodes: evalUTIUrinaryTractInfectionANDhealthConditionsGuard,
    utiRecovery: evalUTIUrinaryTractInfectionANDhealthConditionsGuard,
    stdDiagnosisDate: evalSexuallytransmitteddiseasesANDhealthConditionsGuard,
    conjuctivaDiagnosisDate: evalConjuctivaANDhealthConditionsGuard,
    multiplesclerosisDiagnosis: evalMSMultipleSclerosisGuard,
    multiplesclerosisDailyLivingActivities: evalMSMultipleSclerosisGuard,
    multiplesclerosisTreatment: evalMSMultipleSclerosisGuard,
    musclespasmsDiagnosisDate: evalMuscleSpasmsANDhealthConditionsGuard,
    musclespasmsPendingDiagnosis: evalMuscleSpasmsANDhealthConditionsGuard,
    musclespasmsSypmtoms: evalMuscleSpasmsANDhealthConditionsGuard,
    musclespasmsContinualSymptoms: evalMuscleSpasmsANDhealthConditionsGuard,
    staphDiagnosisDate: evalStaphInfectionANDhealthConditionsGuard,
    covidDiagnosisDate: evalCoronavirusCovid19ANDhealthConditionsGuard,
    eczemaDiagnosis: evalEczemaANDhealthConditionsGuard,
    eczemaDiagnosisDate: evalEczemaANDhealthConditionsGuard,
    exzemaTreatment: evalEczemaANDhealthConditionsGuard,
    psoriasisDiagnosisDate: evalPsoriasisGuard,
    psoriasisPendingDiagnosis: evalPsoriasisGuard,
    psoriasisOralMedications: evalPsoriasisGuard,
    psoriasisTreatmentPlan: evalPsoriasisGuard,
    prostatecancerRemission: evalProstateCancerGuard,
    prostatecancerDiagnosisDate: evalProstateCancerGuard,
    prostatecancerDiagnosisAge: evalProstateCancerGuard,
    prostatecancerRecovery: evalProstateCancerGuard,
    prostatecancerTypeStage: evalProstateCancerGuard,
    prostatecancerTreatment: evalProstateCancerGuard,
    hivDiagnosis: evalHIVAIDSANDhealthConditionsGuard,
    hivDiagnosisDate: evalHIVAIDSANDhealthConditionsGuard,
    hivTreatment: evalHIVAIDSANDhealthConditionsGuard,
    glaucomaDiagnosis: evalGlaucomaANDhealthConditionsGuard,
    glaucomaDiagnosisDate: evalGlaucomaANDhealthConditionsGuard,
    glaucomaTreatment: evalGlaucomaANDhealthConditionsGuard,
    chrohnsdiseaseDiagnosisDate: evalCrohnsDiseaseGuard,
    chronsdiseaseColonscopy: evalCrohnsDiseaseGuard,
    crohnsdiseaseTreatmentPlan: evalCrohnsDiseaseGuard,
    chronsdiseaseSymptoms: evalCrohnsDiseaseGuard,
    opiodSobriertyYears: evalOpioidAddictionANDhealthConditionsGuard,
    opiodaddictionAAMember: evalOpioidAddictionANDhealthConditionsGuard,
    ulcerDiagnosisDate: evalUlcersGuard,
    ulcerEpisodes: evalUlcersGuard,
    ulcerTreatment: evalUlcersGuard,
    ulcerSurgery3: evalUlcersGuard,
    ulcerSurgery2: evalUlcersGuard,
    ulcerSurgery1: evalUlcersGuard,
    ulcerSurgery: evalUlcersGuard,
    petitmalDiagnosisDate: evalSeizuresEpilepsyPetitMalGuard,
    petitmalRecentSeizures: evalSeizuresEpilepsyPetitMalGuard,
    petitmalTreatment: evalSeizuresEpilepsyPetitMalGuard,
    grandmalDiagnosisDate: evalSeizuresEpilepsyGrandMalGuard,
    grandmalRecentSeizures: evalSeizuresEpilepsyGrandMalGuard,
    grandmalTreatment: evalSeizuresEpilepsyGrandMalGuard,
    allergiesSeasonality: evalAllergiesHayFeverANDhealthConditionsGuard,
    allergiesSeverity: evalAllergiesHayFeverANDhealthConditionsGuard,
    allergiesHospitalizations: evalAllergiesHayFeverANDhealthConditionsGuard,
    allergiesTreatmentPlan: evalAllergiesHayFeverANDhealthConditionsGuard,
    strokeDiagnosisDate: evalStrokeGuard,
    strokeAge: evalStrokeGuard,
    strokeLastOccurence: evalStrokeGuard,
    strokeTotalOccurence: evalStrokeGuard,
    strokeTreatmentSymptoms: evalStrokeGuard,
    yeastinfectionDiagnosisDate: evalYeastInfectionANDhealthConditionsGuard,
    painmedicationNumber: evalPainMedicationANDhealthConditionsGuard,
    painmedicationEmployment: evalPainMedicationANDhealthConditionsGuard,
    musclerelaxantDiagnosisDate: evalMuscleRelaxantANDhealthConditionsGuard,
    ulcerativecolitisDiagnosisYears: evalUlcerativeColitisGuard,
    coloscopyCompletedRecently: evalUlcerativeColitisGuard,
    ulcerativecolitisSymptoms: evalUlcerativeColitisGuard,
    ulcerativecolitisTreatment: evalUlcerativeColitisGuard,
    gerdDiagnosisDate: evalGERDHeartburnGuard,
    gerdComplications: evalGERDHeartburnGuard,
    gerdBiopsyCompleted: evalGERDHeartburnGuard,
    gerdBiopsyResults: evalGERDHeartburnGuard,
    gerdTreatmentPlan: evalGERDHeartburnGuard,
    anginaDiagnosisDate: evalAnginaChestPainGuard,
    anginaEvaluation: evalAnginaChestPainGuard,
    anginaTreatment: evalAnginaChestPainGuard,
    fibromyalgiaDiagnosisDate: evalFibromyalgiaGuard,
    fibromyalgiaPendingDiagnosis: evalFibromyalgiaGuard,
    fibromyalgiaSideEffects: evalFibromyalgiaGuard,
    migraineDiagnosisDate: evalHeadachesMigrainesANDhealthConditionsGuard,
    migrainePendingDiagnosis: evalHeadachesMigrainesANDhealthConditionsGuard,
    migrainesSideEffects: evalHeadachesMigrainesANDhealthConditionsGuard,
    hepbDiagnosis: evalHBVHepatitisBVirusANDhealthConditionsGuard,
    hepbDiagnosisDate: evalHBVHepatitisBVirusANDhealthConditionsGuard,
    hepbLiverBiopsy: evalHBVHepatitisBVirusANDhealthConditionsGuard,
    hepBTreatmentPlan: evalHBVHepatitisBVirusANDhealthConditionsGuard,
    hepbUltrasound: evalHBVHepatitisBVirusANDhealthConditionsGuard,
    hepcDiagnosis: evalHCVHepatitisCVirusANDhealthConditionsGuard,
    hepcDiagnosisDate: evalHCVHepatitisCVirusANDhealthConditionsGuard,
    hepcLiverBiopsy: evalHCVHepatitisCVirusANDhealthConditionsGuard,
    hepcTreatmentPlan: evalHCVHepatitisCVirusANDhealthConditionsGuard,
    hepcUltrasound: evalHCVHepatitisCVirusANDhealthConditionsGuard,
    anemiaDiagnosisDate: evalAnemiaANDhealthConditionsGuard,
    anemiaPendingDiagnosis: evalAnemiaANDhealthConditionsGuard,
    anemiaTreatmentPlan: evalAnemiaANDhealthConditionsGuard,
    thyroidDiagnosisDate: evalHyperthyroidismGuard,
    thyroidMalignant: evalHyperthyroidismGuard,
    thyroidPendingDiagnosis: evalHyperthyroidismGuard,
    thyroidSymptoms: evalHyperthyroidismGuard,
    menopauseDiagnosisDate: evalMenopauseANDhealthConditionsGuard,
    tuberculosisDiagnosisDate: evalTuberculosisTBANDhealthConditionsGuard,
    tuberculosisTreatmentCompleted: evalTuberculosisTBANDhealthConditionsGuard,
    hypothyroidismDiagnosisDate: evalHypothyroidismGuard,
    hypthyroidismMalignant: evalHypothyroidismGuard,
    hypothyroidismPendingDiagnosis: evalHypothyroidismGuard,
    hypothyroidismMedications: evalHypothyroidismGuard,
    lbbbDiagnosisDate: evalLeftBundleBranchBlockANDhealthConditionsGuard,
    lbbbAblationDate: evalLeftBundleBranchBlockANDhealthConditionsGuard,
    lbbbSymptoms: evalLeftBundleBranchBlockANDhealthConditionsGuard,
    lbbbTreatmentPlan: evalLeftBundleBranchBlockANDhealthConditionsGuard,
    rbbbDiagnosisDate: evalRightBundleBranchBlockANDhealthConditionsGuard,
    rbbbAblationDate: evalRightBundleBranchBlockANDhealthConditionsGuard,
    rbbbSymptoms: evalRightBundleBranchBlockANDhealthConditionsGuard,
    rbbbTreatmentPlan: evalRightBundleBranchBlockANDhealthConditionsGuard,
    avblockDiagnosisDate: evalAVBlockGuard,
    avblockTreatmentPlan: evalAVBlockGuard,
    avblockAblation: evalAVBlockGuard,
    avblockSymptoms: evalAVBlockGuard,
    diarrheaDiagnosisDate: evalDiarrheaANDhealthConditionsGuard,
    diarrheaPendingDiagnosis: evalDiarrheaANDhealthConditionsGuard,
    diarrheaTreatmentPlan: evalDiarrheaANDhealthConditionsGuard,
    meningitisDiagnosisDate: evalMeningitisANDhealthConditionsGuard,
    addisondiseaseDiagnosisDate: evalAddisonsDiseaseANDhealthConditionsGuard,
    addisondiseasePendingDiagnosis: evalAddisonsDiseaseANDhealthConditionsGuard,
    addisondiseaseSymptoms: evalAddisonsDiseaseANDhealthConditionsGuard,
    addisondiseaseTreatmentPlan: evalAddisonsDiseaseANDhealthConditionsGuard,
    adrenogenitalsyndromeDiagnosisDate: evalAdrenogenitalSyndromeANDhealthConditionsGuard,
    bulimiaDiagnosisDate: evalBulimiaANDhealthConditionsGuard,
    bulimiaTreatmentPlan: evalBulimiaANDhealthConditionsGuard,
    bulimiaCounseling: evalBulimiaANDhealthConditionsGuard,
    bulimiaHospitalization: evalBulimiaANDhealthConditionsGuard,
    ocdDiagnosisDate: evalOCDObsessiveCompulsiveDisorderANDhealthConditionsGuard,
    ocdCondition: evalOCDObsessiveCompulsiveDisorderANDhealthConditionsGuard,
    ocdTreatment: evalOCDObsessiveCompulsiveDisorderANDhealthConditionsGuard,
    ocdEvaluations: evalOCDObsessiveCompulsiveDisorderANDhealthConditionsGuard,
    pagetDiagnosisDate: evalPagetsDiseaseANDhealthConditionsGuard,
    pagetCondition: evalPagetsDiseaseANDhealthConditionsGuard,
    pagetSymptoms: evalPagetsDiseaseANDhealthConditionsGuard,
    pagetBones: evalPagetsDiseaseANDhealthConditionsGuard,
    pagetComplications: evalPagetsDiseaseANDhealthConditionsGuard,
    pagetComplicationDetails: evalPagetsDiseaseANDhealthConditionsGuard,
    pagetSymptomDetails: evalPagetsDiseaseANDhealthConditionsGuard,
    bladderinfectionDiagnosisDate: evalBladderInfectionANDhealthConditionsGuard,
    bladderinfectionPendingTreatment: evalBladderInfectionANDhealthConditionsGuard,
    bladderinfectionTreatmentPlan: evalBladderInfectionANDhealthConditionsGuard,
    liverdiseaseDiagnosis: evalLiverDiseaseGuard,
    liverdiseaseBiopsy: evalLiverDiseaseGuard,
    liverdiseaseTreatment: evalLiverDiseaseGuard,
    kidneydiseaseDiagnosisDate: evalKidneyDisorderKidneyDiseaseGuard,
    kidneydiseaseDialysis: evalKidneyDisorderKidneyDiseaseGuard,
    kidneydiseaseTreatmentPlan: evalKidneyDisorderKidneyDiseaseGuard,
    rlsDiagnosisDate: evalRestlessLegSyndromeRLSANDhealthConditionsGuard,
    cancerDiagnosisDate: evalCancerGuard,
    cancerRemissionYears: evalCancerGuard,
    cancerType: evalCancerGuard,
    cancerStage: evalCancerGuard,
    bacterialinfectionDiagnosisDate: evalBacterialInfectionANDhealthConditionsGuard,
    leukemiaDiagnosisDate: evalLeukemiaGuard,
    leukemiaTreatmentPlan: evalLeukemiaGuard,
    leukemiaRecovery: evalLeukemiaGuard,
    melanomaDiagnosisDate: evalSkinCancerMelanomaGuard,
    melanomaStage: evalSkinCancerMelanomaGuard,
    melanomaTreatmentPlan: evalSkinCancerMelanomaGuard,
    melanomaRecovery: evalSkinCancerMelanomaGuard,
    hypoglycemiaDiagnosisDate: evalHypoglycemiaGuard,
    hypoglycemiaHistory: evalHypoglycemiaGuard,
    hypoglycemiaCondition: evalHypoglycemiaGuard,
    hypoglycemiaA1C: evalHypoglycemiaGuard,
    hypoglycemiaLastEpisode: evalHypoglycemiaGuard,
    hypoglycemiaTreatment: evalHypoglycemiaGuard,
    cysticfibrosisDiagnosis: evalCysticFibrosisANDhealthConditionsGuard,
    cysticfibrosisDiagnosisDate: evalCysticFibrosisANDhealthConditionsGuard,
    nauseaDiagnosisDate: evalNauseaANDhealthConditionsGuard,
    tourettesDiagnosisDate: evalTourettesSyndromeANDhealthConditionsGuard,
    lupusDiagnosisDate: evalLupusGuard,
    lupusSideEffects: evalLupusGuard,
    lupusRecovery: evalLupusGuard,
    lupusComplications: evalLupusGuard,
    lupusTreatmentPlan: evalLupusGuard,
    malariaDiagnosisDate: evalMalariaANDhealthConditionsGuard,
    malariaEpisodes: evalMalariaANDhealthConditionsGuard,
    malariaSymptoms: evalMalariaANDhealthConditionsGuard,
    malariaRecovery: evalMalariaANDhealthConditionsGuard,
    ovariancancerDiangosisDate: evalOvarianCancerGuard,
    ovariancancerRemissionYears: evalOvarianCancerGuard,
    ovariancancerStage: evalOvarianCancerGuard,
    ovariancancerTreatmentPlan: evalOvarianCancerGuard,
    ovariancancerRecovery: evalOvarianCancerGuard,
    lympohomaDiagnosisDate: evalLymphomaGuard,
    lymphomaTypeStage: evalLymphomaGuard,
    lymphomaTreatmentPlan: evalLymphomaGuard,
    lymphomaRecovery: evalLymphomaGuard,
    basalcellDiagnosisDate: evalBasalCellCarcinomaGuard,
    basalcellRecovery: evalBasalCellCarcinomaGuard,
    basalcellMelanoma: evalBasalCellCarcinomaGuard,
    hpvDianosisDate: evalHPVANDhealthConditionsGuard,
    hpvTreatmentPlan: evalHPVANDhealthConditionsGuard,
    hpvCurrentSymptoms: evalHPVANDhealthConditionsGuard,
    emphysemaDiagnosisDate: evalEmphysemaANDhealthConditionsGuard,
    emphysemaResolved: evalEmphysemaANDhealthConditionsGuard,
    emphysemaTreatment: evalEmphysemaANDhealthConditionsGuard,
    emphysemaTreatmentPlan: evalEmphysemaANDhealthConditionsGuard,
    tardiveDiagnosisDate: evalTardiveDyskinesiaANDhealthConditionsGuard,
    acneDiagnosisDate: evalAcneANDhealthConditionsGuard,
    fungalinfectionDiagnosisDate: evalFungalInfectionANDhealthConditionsGuard,
    birthcontrolPrescribedDate: evalBirthControlANDhealthConditionsGuard,
    myelofibrosisDiagnosisDate: evalMyelofibrosisANDhealthConditionsGuard,
    hormonereplacementDiagnoisDate: evalHormoneReplacementTherapyANDhealthConditionsGuard,
    endometriosisDiagnoisDate: evalEndometriosisANDhealthConditionsGuard,
    endometriosisPendingDiangosis: evalEndometriosisANDhealthConditionsGuard,
    endometriosisTreatmentPlan: evalEndometriosisANDhealthConditionsGuard,
    hyperkalemiaDiagnosisDate: evalHyperkalemiaANDhealthConditionsGuard,
    hyperkalemiaElevatedSugar: evalHyperkalemiaANDhealthConditionsGuard,
    hyperkalemiaHemoglobinTest: evalHyperkalemiaANDhealthConditionsGuard,
    hyperkalemiaHbA1C: evalHyperkalemiaANDhealthConditionsGuard,
    hyperkalemiaRecentEpisode: evalHyperkalemiaANDhealthConditionsGuard,
    hyperkalemiaTreatmentPlan: evalHyperkalemiaANDhealthConditionsGuard,
    panicdisorderDiagnosisDate: evalPanicDisorderANDhealthConditionsGuard,
    panicdisorderTreatmentPlan: evalPanicDisorderANDhealthConditionsGuard,
    panicdisorderCounseling: evalPanicDisorderANDhealthConditionsGuard,
    panicDisorderSymptoms: evalPanicDisorderANDhealthConditionsGuard,
    multiplemyelomaDiagnosisDate: evalMultipleMyelomaANDhealthConditionsGuard,
    multiplemyelomaTreatmentPlan: evalMultipleMyelomaANDhealthConditionsGuard,
    multiplemyelomaBloodWork: evalMultipleMyelomaANDhealthConditionsGuard,
    multiplemyelomaRecovery: evalMultipleMyelomaANDhealthConditionsGuard,
    constipationDiagnosisDate: evalConstipationANDhealthConditionsGuard,
    constipationPendingDiagnosis: evalConstipationANDhealthConditionsGuard,
    constipationTreatmentPlan: evalConstipationANDhealthConditionsGuard,
    overactivebladderDiagnosisDate: evalOveractiveBladderANDhealthConditionsGuard,
    overactivebladderTreatmentPlan: evalOveractiveBladderANDhealthConditionsGuard,
    overactivebladderSymptoms: evalOveractiveBladderANDhealthConditionsGuard,
    opioidDiagnosisDate: evalOpioidEmergencyANDhealthConditionsGuard,
    opioidTreament: evalOpioidEmergencyANDhealthConditionsGuard,
    opioidDrugFree: evalOpioidEmergencyANDhealthConditionsGuard,
    opioidTreatmentDetails: evalOpioidEmergencyANDhealthConditionsGuard,
    opioidMember: evalOpioidEmergencyANDhealthConditionsGuard,
    neutropeniaDiagnosisDate: evalNeutropeniaANDhealthConditionsGuard,
    neutropeniaTreatmentPlan: evalNeutropeniaANDhealthConditionsGuard,
    neutropeniaLabWork: evalNeutropeniaANDhealthConditionsGuard,
    neutropeniaRecovery: evalNeutropeniaANDhealthConditionsGuard,
    fibrosisDiagnosisDate: evalIdiopathicPulmonaryFibrosisIPFANDhealthConditionsGuard,
    fibrosisTreatmentPlan: evalIdiopathicPulmonaryFibrosisIPFANDhealthConditionsGuard,
    fibrosisCurrentSymptoms: evalIdiopathicPulmonaryFibrosisIPFANDhealthConditionsGuard,
    gastricbypassSurgeryDate: evalWeightLossObesityGastricANDhealthConditionsGuard,
    fluDiagnosisDate: evalInfluenzaFluANDhealthConditionsGuard,
    fluCurrentSymptoms: evalInfluenzaFluANDhealthConditionsGuard,
    fluRecovery: evalInfluenzaFluANDhealthConditionsGuard,
    ptsdDiagnosisDate: evalPostTraumaticStressDisorderPTSDANDhealthConditionsGuard,
    ptsdSeverity: evalPostTraumaticStressDisorderPTSDANDhealthConditionsGuard,
    ptsdInpatient: evalPostTraumaticStressDisorderPTSDANDhealthConditionsGuard,
    ptsdInpatientDate: evalPostTraumaticStressDisorderPTSDANDhealthConditionsGuard,
    ptsdSideEffects: evalPostTraumaticStressDisorderPTSDANDhealthConditionsGuard,
    ptsdTreatmentPlan: evalPostTraumaticStressDisorderPTSDANDhealthConditionsGuard,
    hypokalemiaDiagnosisDate: evalHypokalemiaANDhealthConditionsGuard,
    hypokalemiaElevatedSugar: evalHypokalemiaANDhealthConditionsGuard,
    hypokalemiaHemoglobinTest: evalHypokalemiaANDhealthConditionsGuard,
    hypokalemiaHbA1C: evalHypokalemiaANDhealthConditionsGuard,
    hypokalemiaRecentEpisode: evalHypokalemiaANDhealthConditionsGuard,
    hypokalemiaTreatmentPlan: evalHypokalemiaANDhealthConditionsGuard,
    congestionDiagnosisDate: evalCongestionANDhealthConditionsGuard,
    excessiveunderarmsweatingDiagnosisDate: evalExcessiveUnderarmSweatingANDhealthConditionsGuard,
    tumorDiagnosisDate: evalTumorANDhealthConditionsGuard,
    tumorDiagnosisType: evalTumorANDhealthConditionsGuard,
    tumorRemoval: evalTumorANDhealthConditionsGuard,
    tumorTreatmentPlan: evalTumorANDhealthConditionsGuard,
    heartarrythmiaDiagnosisDate: evalHeartArrythmiaANDhealthConditionsGuard,
    heartarrythmiaEpisode: evalHeartArrythmiaANDhealthConditionsGuard,
    heartarrythmiaTreatmentPlan: evalHeartArrythmiaANDhealthConditionsGuard,
    heartarrythmiaAblation: evalHeartArrythmiaANDhealthConditionsGuard,
    heartarrythmiaSymptoms: evalHeartArrythmiaANDhealthConditionsGuard,
    shinglesDiagnosisDate: evalShinglesANDhealthConditionsGuard,
    shinglesComplications: evalShinglesANDhealthConditionsGuard,
    shinglesComplicationsExplained: evalShinglesANDhealthConditionsGuard,
    chornicdryeyeDiagnosisDate: evalChronicDryEyeANDhealthConditionsGuard,
    chornicdryeyePhysicianConsult: evalChronicDryEyeANDhealthConditionsGuard,
    tetanusDiagnosisDate: evalTetanusLockjawANDhealthConditionsGuard,
    erectiledysfunctionDiagnosisDate: evalErectileDysfunctionANDhealthConditionsGuard,
    erectilediagnosisPhysicianConsult: evalErectileDysfunctionANDhealthConditionsGuard,
    transplantDiagnosis: evalTransplantANDhealthConditionsGuard,
    transplantDiagnosisDate: evalTransplantANDhealthConditionsGuard,
    transplantTreatmentPlan: evalTransplantANDhealthConditionsGuard,
    coughDiagnosisDate: evalCoughANDhealthConditionsGuard,
    caughCause: evalCoughANDhealthConditionsGuard,
    coughTreatmentPlan: evalCoughANDhealthConditionsGuard,
    coughRecovery: evalCoughANDhealthConditionsGuard,
    cirrhosisDiagnosis: evalCirrhosisoftheLiverANDhealthConditionsGuard,
    cirrhosisDiagnosisDate: evalCirrhosisoftheLiverANDhealthConditionsGuard,
    urinaryretentionDiagnosisDate: evalUrinaryRetentionANDhealthConditionsGuard,
    urinaryretentionPendingDiagnosis: evalUrinaryRetentionANDhealthConditionsGuard,
    urinaryretentionTreatmentPlan: evalUrinaryRetentionANDhealthConditionsGuard,
    urinaryretentionRecovery: evalUrinaryRetentionANDhealthConditionsGuard,
    gallstonesDiagnosisDate: evalGallstonesANDhealthConditionsGuard,
    gallstonesPendingDiagnosis: evalGallstonesANDhealthConditionsGuard,
    gallstonesTreatmentPlan: evalGallstonesANDhealthConditionsGuard,
    smokingcessationDiagnosisDate: evalSmokingCessationQuitSmokingANDhealthConditionsGuard,
    eatingdisorderDiagnosisDate: evalEatingDisorderANDhealthConditionsGuard,
    chronichivesDiagnosiDate: evalChronicHivesANDhealthConditionsGuard,
    polypDiagnosisDate: evalPolypsANDhealthConditionsGuard,
    polypLocation: evalPolypsANDhealthConditionsGuard,
    polypPendingDiagnosis: evalPolypsANDhealthConditionsGuard,
    polypTreatmentPlan: evalPolypsANDhealthConditionsGuard,
    polypBiopsyCompleted: evalPolypsANDhealthConditionsGuard,
    polypBiopsyResults: evalPolypsANDhealthConditionsGuard,
    polypBiopsySurgery: evalPolypsANDhealthConditionsGuard,
    polypRecovery: evalPolypsANDhealthConditionsGuard,
    obstructiveairwaydiseaseDiagnosisDate: evalObstructiveAirwayDiseaseANDhealthConditionsGuard,
    obstructiveairwaydiseaseTreatmentPlan: evalObstructiveAirwayDiseaseANDhealthConditionsGuard,
    obstructiveairwaydiseaseRecovery: evalObstructiveAirwayDiseaseANDhealthConditionsGuard,
    cataplexyDiagnosisDate: evalCataplexyANDhealthConditionsGuard,
    mesotheliomaDiagnosisDate: evalPleuralMesotheliomaANDhealthConditionsGuard,
    mesotheliomaSymptoms: evalPleuralMesotheliomaANDhealthConditionsGuard,
    mesotheliomaLastEpisode: evalPleuralMesotheliomaANDhealthConditionsGuard,
    mesotheliomaRecovery: evalPleuralMesotheliomaANDhealthConditionsGuard,
};
